import axios from 'axios';

const url = process.env.REACT_APP_BACKEND_URL;

export const authenticateLogin = async (user) => {
    try {
        return await axios.post(`${url}/login`, user)
    } catch (error) {
        console.log('error while calling login API: ', error);
    }
}

export const sendQueryForUs= async (user) => {
    try {
        return await axios.post(`${url}/sendQueryForUs`, user)
    } catch (error) {
        console.log('error while calling sendQueryForUs API: ', error);
    }
}

export const authenticateSignup = async (user) => {
    try {
        console.log(url)
        console.log(user)
        return await axios.post(`${url}/signup`, user)
    } catch (error) {
        console.log('error while calling Signup API: ', error);
    }
}
export const authenticateOrganization = async (user) => {
    try {
        return await axios.post(`${url}/organization`, user,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling Organization API: ', error);
    }
}
export const authenticateOthers = async (user) => {
    try {
        return await axios.post(`${url}/otherDetails`, user,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling OtherDetail API: ', error);
    }
}
export const authenticateGetDetail = async () => {
    try {
        return await axios.get(`${url}/getDetails`,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling GetDetail API: ', error);
    }
}
export const authenticateSetDetail = async (user) => {
    try {
        return await axios.post(`${url}/setDetails`, user,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling EditDetail API: ', error);
    }
}

export const sendInData = async (data) =>{
    try{
        console.log(data);
        return await axios.post(`${url}/excelToCollection`, data,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        return error;  
    }
}
export const bringInData = async(data)=>{
    try{
        return await axios.post(`${url}/collectionToExcel`,data,{responseType: 'blob'},{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        console.log('error while calling bringinData API: ', error)
    }
}
export const sendInDataPerTon = async (file) =>{
    try{
        console.log("Uploaded file in sendInData Api ",file);
        return await axios.post(`${url}/excelToCollectionPerTon`, file,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        return error;  
    }
}
export const bringInDataPerTon = async(data)=>{
    try{
        console.log(data);
        return await axios.post(`${url}/collectionToExcelPerTon`,data,{responseType: 'blob'},{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        console.log('error while calling bringinData API: ', error)
    }
}
export const sendInDataFreqLanes = async (data) =>{
    try{
        return await axios.post(`${url}/excelToCollectionFreqLanes`, data,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        console.log('error while calling sendinData API: ', error);   
    }
}
export const bringInDataFreqLanes = async(data)=>{
    try{
        return await axios.post(`${url}/collectionToExcelFreqLanes`,data,{responseType: 'blob'},{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        console.log('error while calling bringinData API: ', error)
    }
}
export const authenticateForgotPass = async (user) => {
    try {
        return await axios.post(`${url}/forgotpassword`, user)
    } catch (error) {
        return {status:400,data:'User with that email does not exist'}
    }
}

export const checkPerKg = async (user) => {
    try {
        console.log(user);
        return await axios.post(`${url}/checkPerKg`, user,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling checkPerKg API: ', error);
    }
}
export const checkPerTonne = async (user) => {
    try {
        console.log(user);
        return await axios.post(`${url}/checkPerTonne`, user,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling checkPerTonne API: ', error);
    }
}
export const checkFreqLanes = async (user) => {
    try {
        console.log(user);
        return await axios.post(`${url}/checkFreqLanes`, user,{ headers: {"Authorization" : localStorage.getItem('SavedToken')}})
    } catch (error) {
        console.log('error while calling checkFreqLanes API: ', error);
    }
}

export const authenticateLoginOauth = async (user) => {
    try {
        return await axios.post(`${url}/loginOAuth`, user)
    } catch (error) {
        console.log('error while calling login API: ', error);
    }
}

export const getAllTheRfqs = async()=>{
    try{
        console.log("inside get All Rfq");
        return await axios.get(`${url}/getAllRfq`)
    }
    catch(error){
        console.log('error while calling getAllRfq:',error);
    }
}

export const getSpecificRfq=async(id)=>{
    try{
        return await axios.post(`${url}/getRfqExcelFile`,id)
    }
    catch(error){
        console.log('error while calling getRfqExcelFile',error);
    }
}

export const getRfqFile=async(data)=>{
    try{
        return await axios.post(`${url}/getRfqFile`,data,{responseType: 'blob'},{ headers: {"Authorization" : localStorage.getItem('SavedToken')}});
    }
    catch(error){
        console.log('error while calling getRfqFile API: ', error)
    }
}
export const submitRfqFile=async(user)=>{
    try{
        return await axios.post(`${url}/submitRfqFile`,user)
    }
    catch(error){
        console.log('error while calling getRfqFile:',error);
    }
}
export const sendInRfqFile = async (data) =>{
    try{
        return await axios.post(`${url}/RfqExcelUpdate`, data);
    }
    catch(error){
        return error;
    }
}
export const updateVisit = async () =>{
    try{
        await axios.get(`https://geolocation-db.com/json/`).then(async (res) => {
            const payload = {
                countryCode: res.data.country_code,
                countryName: res.data.country_name,
                city: res.data.city,
                pin: res.data.postal,
                cord: {
                    lat: res.data.latitude,
                    long: res.data.longitude
                },
                ipAddress: res.data.IPv4,
                state: res.data.state
            }
            try {
                return await axios.post(`${url}/updateVisit`, payload);
            } catch(error) {
                return error;
            }
        })
    }
    catch(error){
        return error;
    }
}
